import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m1.667 7.04 6 3.467a.67.67 0 0 0 .666 0l6-3.467a.666.666 0 0 0 0-1.153l-6-3.467a.67.67 0 0 0-.666 0l-6 3.467a.667.667 0 0 0 0 1.153M8 3.767l4.667 2.666L8 9.133 3.333 6.46zm5.667 5.193L8 12.233 2.333 8.96a.667.667 0 1 0-.666 1.153l6 3.467a.67.67 0 0 0 .666 0l6-3.467a.665.665 0 1 0-.666-1.153"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })